import React from 'react';
import format from 'date-fns/format';
import isToday from 'date-fns/is_today';
import { LiveClassEventType } from 'components/LiveClass/utils/consts';
import { disposeOnUnmount, observer, inject } from 'mobx-react';
import { reaction } from 'mobx';
import InView from 'components/InView';
import { Loader } from '@lyearn-team/frontend-components';
import NotificationMessage from './NotificationMessage';
import ChatMessage from './ChatMessage';
import * as s from './styles';

@inject(stores => ({ model: stores.liveClassModel }))
@observer
class Body extends React.Component {
  constructor(props) {
    super(props);

    this.bodyRef = React.createRef();
  }

  componentDidMount() {
    this.scrollToBottom();

    disposeOnUnmount(this, [
      reaction(
        () => {
          const { store } = this.props.model;
          const { chatMessages } = store.activity;
          const totalMessages = chatMessages.length;
          if (totalMessages < 1) {
            return null;
          }
          return chatMessages[totalMessages - 1].timeStamp;
        },
        () => this.scrollToBottom('smooth'),
        {
          delay: 300,
          fireImmediately: true
        }
      )
    ]);
  }

  scrollToBottom = (behavior) => {
    const element = this.bodyRef.current;
    element.scrollBy({ top: element.scrollHeight, left: 0, behavior });
  };

  renderMessageNode = (chat) => {
    const { store } = this.props.model;
    const { currentUser } = store.activity;

    switch (chat.type) {
      case LiveClassEventType.CARD_COMPLETE:
        return <NotificationMessage chat={chat} currentUser={currentUser} />;
      case LiveClassEventType.CHAT:
        return <ChatMessage chat={chat} currentUser={currentUser} />;
      default:
        return null;
    }
  };

  renderChatItem = (chat) => {
    const { id, timeStamp } = chat;
    const formattedTime = isToday(timeStamp)
      ? format(timeStamp, 'h:mm a')
      : format(timeStamp, 'Do MMM, h:mm a');
    return (
      <div className={s.messageContainer} key={id}>
        {this.renderMessageNode(chat)}
        <div className={s.timeStamp}>{formattedTime}</div>
      </div>
    );
  };

  handleInview = (isInView) => {
    if (!isInView) {
      return;
    }
    const { activity } = this.props.model.store;
    activity.handleFetchMore();
  };

  renderMoreLoader = () => {
    const { store } = this.props.model;
    const { hasMore } = store.activity;

    if (!hasMore) {
      return null;
    }

    return (
      <InView handle={this.handleInview}>
        <div className={s.loaderContainer}>
          <Loader width={25} height={25} />
        </div>
      </InView>
    );
  };

  render() {
    const { store } = this.props.model;
    const { chatMessages } = store.activity;

    return (
      <div className={s.activityBody} ref={this.bodyRef}>
        {this.renderMoreLoader()}
        {chatMessages.map(this.renderChatItem)}
      </div>
    );
  }
}

export default Body;
